import { Box, Paper } from "@mui/material";
import Header from "./Header";
import DataFields from "./DataFields";
import Actions from "./actions";

function OwnerCard() {
  return (
    <>
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
          padding: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: 4,
          }}
        >
          <Header />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignContent: "flex-start",
            padding: 2,
          }}
        >
          <DataFields />
          <Actions />
        </Box>
      </Paper>
    </>
  );
}

export default OwnerCard;
